module.exports = __webpack_public_path__ + "img/friend_text.78b38ed1.svg";